<template>
  <ul class="flex items-center gap-7 overflow-x-auto">
    <li
      v-for="nav in navigationItems"
      :key="nav.name"
    >
      <router-link :to="nav.to" active-class="is-active" class="nav-tab">
        {{ $t(nav.name) }}
      </router-link>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'DashboardNavigation',
  data () {
    return {
      navigationItems: [
        { to: { name: 'dashboard.suggested_stories' }, name: 'components.dashboard_navigation.suggested_stories' },
        { to: { name: 'dashboard.suggested_newsrooms' }, name: 'components.dashboard_navigation.suggested_companies' }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-tab {
  position: relative;
  display: block;
  padding: 14px 0;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #a3aca8;
  white-space: nowrap;
  transition: color 0.12s ease;

  &:hover {
    color: #15191a;
  }

  &.is-active {
    color: #15191a;
  }

  &.is-active::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background: #15191a;
  }
}
</style>
